import ObjectUtils from '../../utils/ObjectUtils';
import { IAddressSchemaNode, IAddressSchema, IAddressSchemaProperties, ISchemaAdditionalProperties } from '../JsonSchemaApi';
import mapDeprecatedFieldNames from '../../helpers/mapDeprecatedFieldNames';

const addressSchemaMapper = {
  response(addressSchema: IAddressSchemaNode): IAddressSchema {
    // standard format
    const properties = addressSchema?.properties || {};
    let required = addressSchema?.required || [];

    // support allOf instruction
    addressSchema?.allOf?.forEach(addressSchemaGroup => {
      ObjectUtils.mergeDeep(properties, addressSchemaGroup.properties || {});
      if (addressSchemaGroup.required) {
        required = [...required, ...addressSchemaGroup.required];
      }
    });

    // include fields that has own required field defined
    required = [...required, ...(Object.keys(properties) as Array<keyof typeof properties>)
      .filter(key => properties[key].required)];

    // TODO: Update JSON schemas normalizing field names, then remove this code when RCO-9875 is done
    Object.keys(properties).forEach((fieldName: keyof IAddressSchemaProperties) => {
      const addressAutoFillFields = properties[fieldName].additionalProperties?.address_auto_fill_fields;
      const addressSuggestionFields = properties[fieldName].additionalProperties?.address_suggestion_fields;
      const dependantFields: Partial<ISchemaAdditionalProperties> = {};

      if (addressAutoFillFields) {
        dependantFields.address_auto_fill_fields = mapDeprecatedFieldNames(addressAutoFillFields);
      }
      if (addressSuggestionFields) {
        dependantFields.address_suggestion_fields = mapDeprecatedFieldNames(addressSuggestionFields);
      }
      
      properties[fieldName] = {
        ...properties[fieldName],
        additionalProperties: {
          ...properties[fieldName].additionalProperties,
          ...dependantFields,
        },
      };
    });

    return {
      properties,
      required,
    };
  },
};

export default addressSchemaMapper;
